import type { SignupRequestData } from './buildSignupRequestData'

export const validateSignupRequestData = (
  reqData: SignupRequestData,
): { isValid: boolean; errors: string[] } => {
  const errors: string[] = []

  // Validate customer object
  if (!reqData.customer) {
    errors.push('customer object is required')
  } else {
    const { customer } = reqData

    if (!customer.email || !customer.email.trim()) {
      errors.push('customer.email is required')
    }

    if (!customer.name_first || !customer.name_first.trim()) {
      errors.push('customer.name_first is required')
    }

    if (!customer.name_last || !customer.name_last.trim()) {
      errors.push('customer.name_last is required')
    }
  }

  return {
    isValid: errors.length === 0,
    errors,
  }
}
